import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const EASE = [0.76, 0, 0.24, 1];

// Placeholder testimonials — swap with verified client quotes later.
const TESTIMONIALS = [
  {
    id: "t1",
    quote:
      "Gerard cut our group health spend without touching the coverage our team relies on. One call, real numbers, no runaround.",
    name: "Michael Grant",
    role: "Operations Director",
    company: "Regional Services Firm",
    avatar: "/testimonial-michael.jpg",
  },
  {
    id: "t2",
    quote:
      "He renegotiated our energy supply and payment processing in the same month. The savings were exactly what he promised.",
    name: "Danielle Ortiz",
    role: "Owner",
    company: "Multi-Location Retailer",
    avatar: "/testimonial-danielle.jpg",
  },
  {
    id: "t3",
    quote:
      "When we needed capital fast, Gerard connected us with funding that actually fit the deal. Hands-on until it closed.",
    name: "Andre Whitfield",
    role: "Managing Partner",
    company: "Real Estate Group",
    avatar: "/testimonial-andre.jpg",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="mx-auto max-w-[90rem] px-6 py-28 md:px-12 md:py-40"
    >
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-6 text-xs uppercase tracking-[0.35em] text-steel"
      >
        Client Proof
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
        className="mb-16 max-w-3xl font-serif text-4xl leading-tight tracking-tight text-fog md:text-6xl"
      >
        The call, working{" "}
        <span className="italic text-steel">on your terms.</span>
      </motion.h2>

      <div className="grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.id}
            data-testid={`testimonial-${t.id}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
            className="flex h-full flex-col justify-between bg-ink p-10 transition-colors duration-500 hover:bg-panel md:p-12"
          >
            <Quote className="h-8 w-8 text-steel/60" />
            <blockquote className="mt-8 flex-1 font-serif text-xl leading-relaxed text-fog md:text-2xl">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-10 flex items-center gap-4 border-t border-white/10 pt-6">
              <img
                src={t.avatar}
                alt={t.name}
                className="h-12 w-12 shrink-0 rounded-full object-cover ring-1 ring-white/15"
              />
              <div>
                <p className="text-sm font-medium tracking-tight text-fog">
                  {t.name}
                </p>
                <p className="mt-1 text-xs uppercase tracking-[0.22em] text-ash">
                  {t.role} · {t.company}
                </p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
